import { gql } from '@apollo/client';
import { EXPORT_INSTITUTION } from '../../fragments';

export const EXPORT_SUBJECT_REPORT_SCHOOLS = gql`
  query ExportSubjectReportSchools($input: ExportArgs!) {
    allSubjectReportSchools(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          ...exportInstitution
        }
      }
    }
  }
  ${EXPORT_INSTITUTION}
`;
